import styles from "../styles/pages/Dossier.module.scss";
import bgImage from 'src/assets/images/dashboard_image.png'

import { format, isValid, subMonths } from "date-fns";
import React, { useEffect, useState, useRef, MutableRefObject } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useOnClickOutside } from "@qastanfit/qastan-ui";
import { Input } from '../components/ui/input'

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import folderClose from '../assets/custom-icons/folder.svg'
import folderOpen from '../assets/custom-icons/folder-open.svg'

import image_icon from "../assets/icons/file_types/image_icon.svg"
import word_icon from "../assets/icons/file_types/word_icon.svg";
import pdf_icon from "../assets/icons/file_types/pdf_icon.svg";
import excel_icon from "../assets/icons/file_types/excel_icon.svg";
import mail_icon from "../assets/icons/file_types/mail_icon.svg";
import text_icon from "../assets/icons/file_types/text_icon.svg";
import unknown_icon from "../assets/icons/file_types/unknown_icon.svg";
import powerpoint_icon from "../assets/icons/file_types/powerpoint_icon.svg";
import FilePreview from "../components/files/FilePreview";
import { useAppDispatch, useAppSelector } from "../hooks/redux";
import { RootState } from "../store";
import { setNotification } from "../redux/actions";
import { getItemById } from "../functions/convert";
import { filterObjectsByValue } from "../functions/general/filter";
import axios from "src/axios/axios";
import useAuth from "src/hooks/useAuth";
import { ChevronLeft, ClipboardTypeIcon, FileIcon, FolderIcon, FolderOpenIcon, HandIcon, Loader2, MessageCircleIcon, MousePointerClickIcon, MoveRightIcon, PaperclipIcon, PlusIcon, Search, SearchIcon, Trash2Icon, X } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/components/ui/table";
import { useTranslation } from "react-i18next";
import { getWindevLang } from "src/lib/lang";
import { ScrollArea, ScrollBar } from "src/components/ui/scroll-area";
import { Button } from "src/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from "src/components/ui/dropdown-menu";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogFooter, AlertDialogTrigger } from "src/components/ui/alert-dialog";
import { Label } from "src/components/ui/label";
import { Combobox } from "src/components/ui/combobox";
import { Textarea } from "src/components/ui/textarea";
import { useMutation, useQuery } from "@tanstack/react-query";
import toast, { Toaster } from "react-hot-toast";
import { promise, z } from "zod";
import { Popover, PopoverContent, PopoverTrigger } from "src/components/ui/popover";
import { Checkbox } from "src/components/ui/checkbox";
import { TreeView } from "src/components/ui/tree-view";
import { Tree, TreeViewElement } from "src/components/ui/tree-view-api";
import { FileInput, FileSvgDraw, FileUploader, FileUploaderContent, FileUploaderItem } from "src/components/ui/file-upload";
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "src/components/ui/resizable";
import { DatePickerWithRangePresetsInput } from "src/components/ui/datepicker-range-presets";
import GroupDropdown from "src/components/base/GroupDropdown";
import { MultiSelect, MultiSelectContent, MultiSelectGroup, MultiSelectItem, MultiSelectList, MultiSelectSearch, MultiSelectTrigger, MultiSelectValue } from "src/components/ui/multi-select";
import { YYYYMMDDtoDate, dateToYYYYMMDD } from "src/functions/format";
import queryString from "query-string";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "src/components/ui/tooltip";
import Preview from "src/components/files/Preview";
import FilePreviewer, { Extension } from "src/components/files/file-previewer"
import { filterDocgroupTypes } from "src/lib/filter";

type AddDocumentProps = {
    dossier: number | string
    onSuccess?: () => void;
}

const AddSelectedDocuments = ({dossier, onSuccess}:AddDocumentProps) => {
    const { auth } = useAuth()
    const { t, i18n } = useTranslation()

    const docgroups:DocgroupObject[] = useAppSelector((state:RootState) => state.docgroups);
    const doctypes:DoctypeObject[] = useAppSelector((state:RootState) => state.doctypes);
    const metatypeList:MetatypeObject[] = useAppSelector((state:RootState) => state.metatypes);

    const [start_date, setstart_date] = useState<Date | undefined>(subMonths(new Date, 1));
    const [end_date, setend_date] = useState<Date | undefined>(new Date());
    const startdate = useRef<Date | undefined>(subMonths(new Date, 1));
    const enddate = useRef<Date | undefined>(new Date());

    const [search_value, setsearch_value] = useState('');
    const searchvalue = useRef<string>('');

    const [checked_searchcontent, setchecked_searchcontent] = useState<boolean>(false);
    const checkedsearchcontent = useRef<boolean>(false);    

    const [selected_doctypes, setselected_doctypes] = useState<string[]>([]);
    const selecteddoctypes = useRef<string[]>([])

    const [preview_document, setpreview_document] = useState<DocumentObject | undefined>(undefined);
    const [added_documents, setadded_documents] = useState<DocumentObject[]>([]);

    const { data:status } = useQuery<Status[] | null>({
        queryKey: [`status`],
        queryFn: async () => {
            try {
                const { data } = await axios.get(`${process.env.REACT_APP_SERVER_LINK}status/list?token=${auth.data?.token}`)
                if(data.errorcode!==0){throw new Error(data.message)}
                return data.object
            } catch (error) {
                console.log(error);
                return null
            }
        }
    })

    const { data:documents, refetch:getDocuments, isLoading:isSearching } = useQuery<DocumentObject[] | null>({
        queryKey: [`${search_value}_${checked_searchcontent.toString()}_${start_date?.toISOString()}_${end_date?.toISOString()}_${JSON.stringify(selecteddoctypes.current)}`],
        queryFn: async (props) => {
            try {
                const searchObject = {
                    token: auth.data?.token,
                    searchstring: searchvalue.current,
                    searchcontent: checkedsearchcontent.current ? 1 : 0,
                    startdate: '',
                    enddate: '',
                    doctypes: '',
                    offset: (typeof props.pageParam === 'number' ? props.pageParam : 0)*50,
                    limit: 50
                }
        
                if(startdate.current){
                    searchObject.startdate = dateToYYYYMMDD(startdate.current)
                }
        
                if(enddate.current){
                    searchObject.enddate = dateToYYYYMMDD(enddate.current)
                }
        
                if(Array.isArray(selecteddoctypes.current)){
                    searchObject.doctypes = selecteddoctypes.current.join(";")
                }
        
                const params = queryString.stringify(searchObject).replace(/%3B/g, ';');

                const { data } = await axios.get(`documents/getbyfilter?${params}`)
                if(data.errorcode!==0){ throw new Error(data.message) }
                return data.object
            } catch (error) {
                console.log(error);
                return null
            }
        },
        enabled: false
    })

    const { mutate:addDocuments, isPending } = useMutation({
        mutationFn: async () => {
            try {
                toast.loading('Documenten toevoegen...', { id:'add-documents' })
                const { data } = await axios.post('dossiers/adddocument', {
                    token: auth.data?.token,
                    dossierentityid: dossier,
                    docids: added_documents.map((d)=>d.docid)
                })
                if(data.errorcode!==0){ throw new Error(data.message) }
                toast.success('Documenten succesvol toegevoegd', { id:'add-documents' })
                setadded_documents([])
                onSuccess&&onSuccess()
            } catch (error) {
                toast.error('Documenten toevoegen mislukt', { id:'add-documents' })
            }
        }
    })

    const extensionToIcon = (extension:string) => {
        switch (extension) {
            case 'doc': case 'docx':
                return word_icon
            case 'xlsx':
                return excel_icon
            case 'pdf':
                return pdf_icon
            case 'txt':
                return text_icon
            case 'ppt': case 'pptx':
                return powerpoint_icon
            case 'eml':
                return mail_icon;
            case 'jpg': case 'jpeg': case 'png':
                return image_icon;
            default:
                return unknown_icon
        }
    }

    const getColumns = (results:DocumentObject[]) => {
        if(!metatypeList){ return [] }
        if(!results){ return [] }
        let result:any[] = []
        let metatypeArray:string[] = []
        results.forEach(element => {
            if(element && element.metadata){
                return element.metadata.forEach(md => {
                    if(!metatypeArray.includes(md.metatype)){ metatypeArray.push(md.metatype) }
                })
            }
        });
        result = metatypeArray.filter(mt => {
            const item = metatypeList.find(i=>i.metatype===mt)
            return item?.columndisplay
        })
        return result
    }

    const getStatusIcons = (document:DocumentObject) => {
        let statusIcons:number[] = []

        if(!document){ return []}

        document.status?.forEach(status => statusIcons.push(status))
        
        if(status){
            status.forEach(state => {
                state.metadata?.forEach(meta => {
                    const metaInDoc = document.metadata?.find(i=>i.metatype===meta.Metatype)
                    if(metaInDoc?.metavalue === meta.Metadata){
                        console.log("Metadata status equal")
                        if(!statusIcons.includes(state.statusid)){ statusIcons.push(state.statusid) }
                    }
                })
            })
        }

        return statusIcons
    }

    return (
        <AlertDialogContent id="add-selected-document" className="p-0 gap-0 w-fit max-w-[90dvw] max-h-[90dvh] overflow-auto">
            <div className="grid grid-cols-2 gap-4 p-4">
                <div>
                    <Label htmlFor="date">{t('Begin en einddatum')}</Label>
                    <DatePickerWithRangePresetsInput value={{from:start_date, to:end_date}} onDateChange={(range)=>{startdate.current = range?.from; enddate.current = range?.to; setstart_date(range?.from); setend_date(range?.to)}} className="bg-slate-200 rounded-sm min-w-[250px]" placeholder={t('Selecteer een datum') || ''} id="date"/>
                </div>
                <div>
                    <Label htmlFor="doctypes">{t('Documenttypes')}</Label>
                    <MultiSelect value={selected_doctypes} onValueChange={(v)=>{setselected_doctypes(v); selecteddoctypes.current = v}} modal={true}>
                        <MultiSelectTrigger className="h-10"><MultiSelectValue /></MultiSelectTrigger>
                        <MultiSelectContent className="z-[51]">
                            <MultiSelectSearch />
                            <MultiSelectList>
                                {Array.isArray(docgroups) && docgroups.map((dg) => (
                                    <MultiSelectGroup heading={dg.nations.find(n=>n.nationid === getWindevLang(i18n.language))?.oms || 'Onbekend'} key={`msg-${dg.docgroupid}`}>
                                        {filterDocgroupTypes(dg.doctypes, doctypes, 'create')?.map((dt)=>(
                                            <MultiSelectItem value={dt.doctype} key={`dt-${dt.doctype}`}>{doctypes?.find(d => d.doctype === dt.doctype)?.docoms.find(n=>n.nationid===getWindevLang(i18n.language))?.oms || dt.doctype}</MultiSelectItem>
                                        ))}
                                    </MultiSelectGroup>
                                ))}
                            </MultiSelectList>
                        </MultiSelectContent>
                    </MultiSelect>
                </div>
                <div className="col-span-full">
                    <div className="flex items-end justify-between mb-1">
                        <Label htmlFor="search">{t('Zoekterm')}</Label>
                        <Checkbox checked={checked_searchcontent} onCheckedChange={(c)=>{checkedsearchcontent.current = c as boolean; setchecked_searchcontent(c as boolean)}}><p style={{fontSize:".8rem"}}>{t('Zoeken op inhoud')}</p></Checkbox>
                    </div>
                        
                    <Input id="search" value={search_value} onChange={({target}) => {searchvalue.current = target.value; setsearch_value(target.value)}} placeholder={`${t('Zoekterm')}...`} startEnhancer={<SearchIcon className="w-4 h-4 text-neutral-400"/>}/>
                </div>
                <div>
                    <Button onClick={()=>{getDocuments()}} disabled={isSearching} className="gap-2">
                        {isSearching && <Loader2 className="w-4 h-4 animate-spin"/>}
                        Zoeken
                    </Button>
                </div>
            </div>
            <div className="overflow-auto border-y">
                <ResizablePanelGroup direction="horizontal">
                    <ResizablePanel>
                        <div className="p-3">
                            <p className="text-sm font-medium">Zoekresultaten</p>
                        </div>
                        <div className="overflow-auto max-h-[400px]">
                            <div className="relative flex flex-col gap-4">
                                {Array.isArray(documents) && 
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHead className="p-2">{t('Status')}</TableHead>
                                            <TableHead className="p-2 whitespace-nowrap">{t('Doc datum')}</TableHead>
                                            <TableHead className="p-2">{t('Type')}</TableHead>
                                            <TableHead className="p-2"></TableHead>
                                            <TableHead className="p-2">{t('Bestandsinfo')}</TableHead>
                                            {getColumns(documents).map((v, i)=>(
                                                <TableHead key={i}>{metatypeList.find(i=>i.metatype===v)?.metatype_oms?.find(i=>i.nationid===getWindevLang(i18n.language))?.oms || v}</TableHead>
                                            ))}
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {documents.map((doc, ind)=>{
                                            const exists = !!added_documents.find(i=>i.docid === doc.docid)

                                            if(!doc || exists){ return <React.Fragment key={ind}></React.Fragment>}

                                            return(
                                            <TableRow key={ind} className="hover:bg-blue-50 group">
                                                <TableCell>
                                                    <div className="absolute right-0 flex items-center justify-center h-10 px-1 -translate-y-5 bg-white border-l rounded-l-full border-y">
                                                        <button onClick={()=>{setadded_documents(p=>[...p, doc])}} className="flex items-center justify-center w-8 h-8 text-green-600 bg-green-100 rounded-full hover:bg-green-200"><MoveRightIcon className="w-4 h-4"/></button>
                                                    </div>
                                                    <div className="flex items-center gap-1">
                                                    
                                                        {getStatusIcons(doc).map((status_id, index)=>(
                                                        <TooltipProvider key={`${status_id}-${doc.docid}`}>
                                                            <Tooltip delayDuration={50}>
                                                                <TooltipTrigger><img key={status_id} className="w-5 h-5" src={`data:image/png;base64, ${status ? (status.find(i=>i.statusid===status_id)?.icon) : ''}`}/></TooltipTrigger>
                                                                <TooltipContent>{status ? (status.find(i=>i.statusid===status_id)?.description || status.find(i=>i.statusid===status_id)?.name) : ''}</TooltipContent>
                                                            </Tooltip>
                                                        </TooltipProvider>
                                                        ))}
                                                        {doc.remarks?.length > 0 && <MessageCircleIcon className="w-5 h-5 text-teal-400 fill-teal-300"/>}
                                                    </div>
                                                </TableCell>
                                                <TableCell onClick={()=>{setpreview_document(doc)}} className="p-2 cursor-pointer group-hover:text-blue-600">{YYYYMMDDtoDate(doc.docdate) ? format(YYYYMMDDtoDate(doc.docdate), "dd/MM/yyyy") : ''}</TableCell>
                                                <TableCell onClick={()=>{setpreview_document(doc)}} className="p-2 cursor-pointer group-hover:text-blue-600">{doctypes ? (doctypes.find(i=>i.doctype===doc.doctype)?.docoms.find(i=>i.nationid === getWindevLang(i18n.language))?.oms) : doc.doctype}</TableCell>
                                                <TableCell onClick={()=>{setpreview_document(doc)}} className="p-2 cursor-pointer group-hover:text-blue-600"><img className="w-6 min-w-[24px] h-6" src={extensionToIcon(doc.filename.split('.')[doc.filename.split('.').length-1])} /></TableCell>
                                                <TableCell onClick={()=>{setpreview_document(doc)}} className="p-2 cursor-pointer group-hover:text-blue-600">
                                                    <div className="flex flex-col gap-1 overflow-auto">
                                                        <p className="text-inherit">DOCID: {doc.docid}</p>
                                                        <p className="text-inherit line-clamp-2">{t('Bestand')}: {doc.filename}</p>
                                                    </div>
                                                </TableCell>
                                                {getColumns(documents).map((v, i)=>(
                                                    <TableCell key={i}>{doc?.metadata?.find((md:any) => md.metatype === v)?.metavalue || ''}</TableCell>
                                                ))}
                                            </TableRow>
                                        )})}
                                    </TableBody>
                                </Table>
                                }
                            </div>
                        </div>
                    </ResizablePanel>
                    <ResizableHandle withHandle/>
                    <ResizablePanel maxSize={450}>
                        <div className="p-3">
                            <p className="text-sm font-medium">Preview</p>
                        </div>
                        <div className="max-w-lg max-h-[400px] overflow-auto w-full relative">
                            {(!preview_document && (Array.isArray(documents) && documents?.length > 0)) && <p className="px-3 text-sm italic text-center text-neutral-400">Klik op een document om te bekijken</p>}
                            {preview_document && <Preview filename={preview_document.filename} docid={preview_document.docid}/>}
                        </div>
                    </ResizablePanel>
                    <ResizableHandle withHandle/>
                    <ResizablePanel>
                        <div className="p-3">
                            <p className="text-sm font-medium">Geselecteerde documenten</p>
                        </div>
                        <div className="overflow-auto max-h-[400px]">
                            <div className="relative flex flex-col gap-4">
                                {(documents && Array.isArray(documents)) && (Array.isArray(added_documents) && added_documents.length === 0) && <p className="px-3 text-sm italic text-center text-neutral-400">Nog geen geselecteerde documenten</p>}
                                {(Array.isArray(added_documents) && added_documents.length > 0) && 
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHead className="p-2">{t('Status')}</TableHead>
                                            <TableHead className="p-2 whitespace-nowrap">{t('Doc datum')}</TableHead>
                                            <TableHead className="p-2">{t('Type')}</TableHead>
                                            <TableHead className="p-2"></TableHead>
                                            <TableHead className="p-2">{t('Bestandsinfo')}</TableHead>
                                            {getColumns(added_documents).map((v, i)=>(
                                                <TableHead key={i}>{metatypeList.find(i=>i.metatype===v)?.metatype_oms?.find(i=>i.nationid===getWindevLang(i18n.language))?.oms || v}</TableHead>
                                            ))}
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {added_documents.map((doc, ind)=>{
                                            if(!doc){ return <></>}
                                            return(
                                            <TableRow key={ind} className="hover:bg-blue-50 group">
                                                <TableCell>
                                                    <div className="absolute left-0 flex items-center justify-center h-10 px-1 -translate-y-5 bg-white border-r rounded-r-full border-y">
                                                        <button onClick={()=>{setadded_documents(p=>[...p.filter(i=>i.docid!==doc.docid)])}} className="flex items-center justify-center w-8 h-8 text-red-600 bg-red-100 rounded-full hover:bg-red-200"><Trash2Icon className="w-4 h-4"/></button>
                                                    </div>
                                                    <div className="flex items-center gap-1">
                                                    
                                                        {getStatusIcons(doc).map((status_id, index)=>(
                                                        <TooltipProvider key={`${status_id}-${doc.docid}`}>
                                                            <Tooltip delayDuration={50}>
                                                                <TooltipTrigger><img key={status_id} className="w-5 h-5" src={`data:image/png;base64, ${status ? (status.find(i=>i.statusid===status_id)?.icon) : ''}`}/></TooltipTrigger>
                                                                <TooltipContent>{status ? (status.find(i=>i.statusid===status_id)?.description || status.find(i=>i.statusid===status_id)?.name) : ''}</TooltipContent>
                                                            </Tooltip>
                                                        </TooltipProvider>
                                                        ))}
                                                        {doc.remarks?.length > 0 && <MessageCircleIcon className="w-5 h-5 text-teal-400 fill-teal-300"/>}
                                                    </div>
                                                </TableCell>
                                                <TableCell onClick={()=>{setpreview_document(doc)}} className="p-2 cursor-pointer group-hover:text-blue-600">{YYYYMMDDtoDate(doc.docdate) ? format(YYYYMMDDtoDate(doc.docdate), "dd/MM/yyyy") : ''}</TableCell>
                                                <TableCell onClick={()=>{setpreview_document(doc)}} className="p-2 cursor-pointer group-hover:text-blue-600">{doctypes ? (doctypes.find(i=>i.doctype===doc.doctype)?.docoms.find(i=>i.nationid === getWindevLang(i18n.language))?.oms) : doc.doctype}</TableCell>
                                                <TableCell onClick={()=>{setpreview_document(doc)}} className="p-2 cursor-pointer group-hover:text-blue-600"><img className="w-6 min-w-[24px] h-6" src={extensionToIcon(doc.filename.split('.')[doc.filename.split('.').length-1])} /></TableCell>
                                                <TableCell onClick={()=>{setpreview_document(doc)}} className="p-2 cursor-pointer group-hover:text-blue-600">
                                                    <div className="flex flex-col gap-1 overflow-auto">
                                                        <p className="text-inherit">DOCID: {doc.docid}</p>
                                                        <p className="text-inherit line-clamp-2">{t('Bestand')}: {doc.filename}</p>
                                                    </div>
                                                </TableCell>
                                                {getColumns(added_documents).map((v, i)=>(
                                                    <TableCell key={i}>{doc?.metadata?.find((md:any) => md.metatype === v)?.metavalue || ''}</TableCell>
                                                ))}
                                            </TableRow>
                                        )})}
                                    </TableBody>
                                </Table>
                                }
                            </div>
                        </div>
                    </ResizablePanel>
                </ResizablePanelGroup>
            </div>
            <div className="flex justify-end gap-2 p-4">
                <AlertDialogCancel>Annuleren</AlertDialogCancel>
                <AlertDialogAction onClick={()=>{addDocuments()}} disabled={added_documents.length === 0 || isPending}>
                    {isPending && <Loader2 className="w-4 h-4 animate-spin"/>}
                    Opslaan
                </AlertDialogAction>
            </div>
        </AlertDialogContent>
    )
}

const AddManualDocument = ({dossier}:AddDocumentProps) => {
    const { auth } = useAuth()
    const { t, i18n } = useTranslation()

    const doctypes:DoctypeObject[] = useAppSelector((state:RootState)=>state.doctypes)
    const docgroups:DocgroupObject[] = useAppSelector((state:RootState) => state.docgroups);

    const [date_add, setdate_add] = useState(format(new Date(), "yyyy-MM-dd"));
    const [doctype, setdoctype] = useState<string | undefined>(undefined);
    const [text, settext] = useState("");

    const { mutate } = useMutation({
        mutationFn: async () => {
            try {
                toast.loading('Document toevoegen...', { id:'add-document' })
                const b64 = await stringToBase64TxtFile(text);
                const { data } = await axios.post('documents/add', {
                    token: auth.data?.token,
                    filename : `${date_add}.txt`,
                    file: b64,
                    doctype: doctype,
                    dossiers: [{dossierentityid:dossier}]
                })
                if(data.errorcode!==0){ throw new Error(data.message) }
                toast.success('Document succesvol toegevoegd', { id:'add-document' })
            } catch (error) {
                console.log(error);
                toast.error('Document toevoegen mislukt', { id:'add-document' })
            }
        }
    })

    function stringToBase64TxtFile(str: string): Promise<string> {
        return new Promise((resolve, reject) => {
          // Create a Blob from the string
          const blob = new Blob([str], { type: 'text/plain' });
      
          // Create a FileReader to read the Blob as a data URL
          const reader = new FileReader();
      
          // Define what happens when the FileReader finishes reading
          reader.onloadend = function() {
            // Check that reader.result is a string
            if (typeof reader.result === 'string') {
              // The result will be a data URL containing the base64-encoded string
              const dataUrl = reader.result;
      
              // Extract the base64 part from the data URL
              const base64String = dataUrl.split(',')[1];
              resolve(base64String);
            } else {
              reject(new Error('Unexpected result type'));
            }
          };
      
          // Define what happens if there's an error
          reader.onerror = function() {
            reject(new Error('Error reading the Blob as a data URL'));
          };
      
          // Start reading the Blob as a data URL
          reader.readAsDataURL(blob);
        });
      }

    function isComplete () {
        try {
            const s = z.object({
                date: z.string().min(1),
                doctype: z.string().min(1),
                text: z.string().min(1)
            })
            s.parse({
                date: date_add,
                doctype: doctype,
                text: text
            })
            return true
        } catch (error) {
            return false
        }
    }
    
    return (
        <AlertDialogContent>
            <div className="flex flex-col gap-4">
                <div>
                    <Label>Datum van toevoegen<span className="ml-1 text-primary">*</span></Label>
                    <Input value={date_add} onChange={({currentTarget})=>{setdate_add(currentTarget.value)}} type="date" />
                </div>
                <div>
                    <Label htmlFor="doctypes">{t('Documenttypes')}</Label>
                    <MultiSelect value={doctype ? [doctype] : undefined} onValueChange={(v)=>{setdoctype(v[0])}} modal={true}>
                        <MultiSelectTrigger className="h-10"><MultiSelectValue /></MultiSelectTrigger>
                        <MultiSelectContent className="z-[51]">
                            <MultiSelectSearch />
                            <MultiSelectList>
                                {Array.isArray(docgroups) && docgroups.map((dg) => (
                                    <MultiSelectGroup heading={dg.nations.find(n=>n.nationid === getWindevLang(i18n.language))?.oms || 'Onbekend'} key={`msg-${dg.docgroupid}`}>
                                        {filterDocgroupTypes(dg.doctypes, doctypes, 'create')?.map((dt)=>(
                                            <MultiSelectItem value={dt.doctype} key={`dt-${dt.doctype}`}>{doctypes?.find(d => d.doctype === dt.doctype)?.docoms.find(n=>n.nationid===getWindevLang(i18n.language))?.oms || dt.doctype}</MultiSelectItem>
                                        ))}
                                    </MultiSelectGroup>
                                ))}
                            </MultiSelectList>
                        </MultiSelectContent>
                    </MultiSelect>
                </div>
                <div>
                    <Label>Bericht<span className="ml-1 text-primary">*</span></Label>
                    <Textarea value={text} onChange={({currentTarget})=>{settext(currentTarget.value)}} placeholder="Begin met typen..."/>
                </div>
            </div>
            <AlertDialogFooter>
                <AlertDialogCancel>Annuleren</AlertDialogCancel>
                <AlertDialogAction disabled={!isComplete()} onClick={()=>{mutate()}}>Opslaan</AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    )
}

const AddNewDocument = ({dossier}:AddDocumentProps) => {
    const { auth } = useAuth()
    const { i18n } = useTranslation()
    const docgroups:DocgroupObject[] = useAppSelector((state:RootState)=>state.docgroups)
    const doctypes:DoctypeObject[] = useAppSelector((state:RootState)=>state.doctypes)
    const metatypes:MetatypeObject[] = useAppSelector((state:RootState)=>state.metatypes)
    


    const elements:TreeViewElement[] = (docgroups.map((dg, idg)=>(
        {
            id:`${dg.docgroupid}`,
            name: (dg.nations.find(n => n.nationid === getWindevLang(i18n.language))?.oms || dg.nations[0].oms), 
            children: filterDocgroupTypes(dg.doctypes, doctypes, 'create')?.map((dt, idt)=>(
                {
                    id:dt.doctype, 
                    name: (Array.isArray(doctypes) ? (doctypes.find(d=>d.doctype===dt.doctype)?.docoms.find(n => n.nationid === getWindevLang(i18n.language))?.oms || dt.doctype) : dt.doctype)
                }
            ))
        }
    )))

    const dropZoneConfig = {
        maxFiles: 1,
        maxSize: 1024 * 1024 * 4,
        multiple: false,
    };

    const [selected_doctype, setselected_doctype] = useState<undefined | string>(undefined);
    const [files, setFiles] = useState<File[] | null>(null);
    const [files_base64, setfiles_base64] = useState<(string | null)[] | null>(null);
    const [filled_metadata, setfilled_metadata] = useState<{[metatype:string]:string}>({});

    const { mutate, isPending } = useMutation({
        mutationFn: async () => {
            try {
                if(!files){ throw new Error('Please select a document') }
                toast.loading('Document toevoegen...', { id:'add-document' })
                const file = await fileToBase64(files[0])
                const { data } = await axios.post('documents/add', {
                    token: auth.data?.token,
                    dossiers: [{dossierentityid:dossier}],
                    doctype: selected_doctype,
                    filename: file.filename,
                    file: file.base64,
                    metatypes: Object.keys(filled_metadata).map((metatype)=>({metatype:metatype, value:filled_metadata[metatype]}))
                })
                if(data.errorcode!==0){ throw new Error(data.message) }
                toast.success('Document succesvol toegevoegd', { id:'add-document' })
            } catch (error) {
                toast.error('Document toevoegen mislukt', { id:'add-document' })
            }
        }
    })

    const fileToBase64 = (file: File): Promise<{ base64: string; filename: string }> => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            if (reader.result) {
              const base64String = (reader.result as string).split(',')[1];
              resolve({ base64: base64String, filename: file.name });
            } else {
              reject(new Error("File could not be read"));
            }
          };
          reader.onerror = () => {
            reject(new Error("File reading has failed"));
          };
          reader.readAsDataURL(file);
        });
    };

    function changeMetadata (metatype:string, metavalue:string) {
        setfilled_metadata(p => {
            let u = {...p}
            u[metatype] = metavalue
            return u
        })
    }

    function metatypeToName (metatype:string) {
        let result = metatype;
        if(!Array.isArray(metatypes)){ return result };
        const mt = metatypes.find(i=>i.metatype === metatype);
        if(!mt) { return result };
        const oms = mt.metatype_oms.find(n=>n.nationid===getWindevLang(i18n.language))?.oms
        if(!oms) { return mt.metatype_oms[0].oms }
        return oms
    }

    function isFormComplete (values:{[metatype:string]:string}) {
        const required = doctypes.find(i=>i.doctype===selected_doctype)?.metatypes.filter(i=>i.required).map(v=>v.metatype) || []

        if(required.length !== Object.keys(values).length){ return false }

        for (const metatype of Object.keys(values)) {
            if (required.includes(metatype)) {
                try { const s = z.object({v:z.string().min(1)}); s.parse({v:values[metatype]}) } catch (e) { return false }
            }
        }
        return true; // All required metatypes have values
    };

    function isComplete () {
        try {
            // const formComplete = isFormComplete(filled_metadata);
            // if(!formComplete){ return false; }

            const s = z.object({
                doctype: z.string().min(1),
                file: z.array(z.any()).min(1)
            })
            s.parse({
                doctype: selected_doctype,
                file: files
            })
            return true
        } catch (error) {
            return false
        }
    }

    useEffect(()=>{
        async function convertToBase64 () {
            const promises = files && await Promise.all(files.map(async (file) => {
                const f = files && await fileToBase64(files[0])
                if(f) { return f.base64 }
                return null
            }).filter(i=>i!==null))
            
            setfiles_base64(promises)
        }
        
        if(files){
            convertToBase64()
        } else { 
            setfiles_base64(null)
        }
    }, [files])

    return (
        <>
        <AlertDialogContent id="add-new-document" overlayClassName='bg-black/60' className='overflow-auto p-0 flex max-h-[calc(100%-32px)] max-w-[1080px] min-w-[288px] min-h-[176px] w-full h-[680px] mx-8 gap-0'>
            <div className="w-[250px] h-full bg-slate-100">
                <TreeView 
                    elements={elements} 
                    expandAll 
                    className="h-full" 
                    openIcon={<img src={folderOpen} className="w-4 h-4" alt="folder open"/>}
                    closeIcon={<img src={folderClose} className="w-4 h-4" alt="folder open"/>}
                    fileIcon={<FileIcon className="w-4 h-4 text-slate-500"/>}
                    onClickElement={(elementId)=>{setselected_doctype(elementId)}}
                />
            </div>
            <div className="flex flex-col justify-between w-full p-4 md:p-4">
                <div className="w-full pb-4 border-b md:pb-4">
                    <FileUploader value={files} onValueChange={setFiles} dropzoneOptions={dropZoneConfig} className="relative p-2 rounded-lg bg-slate-100">
                        <FileInput>
                            <div className="flex flex-col items-center justify-center w-full pt-3 pb-4 ">
                                <FileSvgDraw />
                            </div>
                        </FileInput>
                        <FileUploaderContent>
                            {files &&
                            files.length > 0 &&
                            files.map((file, i) => (
                                <FileUploaderItem key={i} index={i}>
                                    <PaperclipIcon className="w-4 h-4 stroke-current" />
                                    <span>{file.name}</span>
                                </FileUploaderItem>
                            ))}
                        </FileUploaderContent>
                    </FileUploader>
                </div>

                <div className="flex flex-col h-full gap-4 py-4 overflow-auto md-py-4">
                    <p className="w-full py-1 text-sm font-medium text-center border rounded-md text-slate-600">
                        {selected_doctype 
                        ? <>{Array.isArray(doctypes) ? doctypes.find(i=>i.doctype === selected_doctype)?.docoms.find(n => n.nationid === getWindevLang(i18n.language))?.oms : selected_doctype}</>
                        : <>Selecteer een documenttype</>
                        }
                    </p>
                    
                    
                    {(files_base64 && files) && (files_base64.length > 0) && (files.length === files_base64.length) ? files_base64.map((base64, index) => {
                        return (
                            <ScrollArea>
                                <div className="flex flex-col w-full h-full">
                                    <div>
                                        <FilePreviewer options={{pdf:{zoom:0.5, showSidebar:false}}} base64={base64 || ''} extension={files[index].name.split('.').pop() as Extension} key={index}/>
                                    </div>
                                </div>
                                <ScrollBar orientation="horizontal"/>
                            </ScrollArea>
                        )
                    }) :
                    <></>
                    }
                        
                    
                    {/* {(selected_doctype && Array.isArray(doctypes)) && 
                    <div className="flex flex-col gap-4 overflow-auto">
                        {doctypes.find(i=>i.doctype===selected_doctype)?.metatypes?.map((metatype)=>(
                            <div key={`input-${metatype.metatype}`}>
                                <Label>{metatypeToName(metatype.metatype)} {metatype.required ? <span className="text-primary">*</span> : ''}</Label>
                                <Input value={filled_metadata[metatype.metatype] || ''} onChange={({currentTarget})=>{changeMetadata(metatype.metatype, currentTarget.value)}}/>
                            </div>
                        ))}
                    </div>
                    } */}
                    
                </div>
                
                <AlertDialogFooter className="pt-4 border-t md:pt-4">
                    <AlertDialogCancel>Annuleren</AlertDialogCancel>
                    <AlertDialogAction asChild>
                        <Button onClick={()=>{mutate()}} disabled={!isComplete() || isPending} className="gap-2">
                            {isPending && <Loader2 className="w-4 h-4 animate-spin"/>}
                            Opslaan
                        </Button>
                    </AlertDialogAction>
                </AlertDialogFooter>
                

            </div>
        </AlertDialogContent>
        </>
    )
}

const New = ({dossier}:AddDocumentProps) => {   
    const [open_dropdownmenu, setopen_dropdownmenu] = useState(false);

    const [open_addnewdocument, setopen_addnewdocument] = useState(false);
    const [open_addselecteddocuments, setopen_addselecteddocuments] = useState(false);
    const [open_addmanualdocument, setopen_addmanualdocument] = useState(false);

    return (
        <>
            <DropdownMenu open={open_dropdownmenu} onOpenChange={(o)=>{setopen_dropdownmenu(o)}}>
                <DropdownMenuTrigger asChild>
                    <Button className="gap-2"><PlusIcon className="w-4 h-4"/>Nieuw</Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent side="bottom" align="end">
                    <DropdownMenuGroup>
                        <DropdownMenuItem onSelect={(e)=>{e.preventDefault()}} onClick={()=>{setopen_dropdownmenu(false); setopen_addnewdocument(true)}} className="p-0"><button className="flex items-center w-full h-full p-2"><PlusIcon className="w-4 h-4 mr-2" strokeWidth={1}/>Nieuw document toevoegen</button></DropdownMenuItem>
                        <DropdownMenuItem onSelect={(e)=>{e.preventDefault()}} onClick={()=>{setopen_dropdownmenu(false); setopen_addmanualdocument(true)}} className="p-0"><button className="flex items-center w-full h-full p-2"><ClipboardTypeIcon className="w-4 h-4 mr-2" strokeWidth={1}/>Document manueel toevoegen</button></DropdownMenuItem>
                        <DropdownMenuItem onSelect={(e)=>{e.preventDefault()}} onClick={()=>{setopen_dropdownmenu(false); setopen_addselecteddocuments(true)}} className="p-0"><button className="flex items-center w-full h-full p-2"><MousePointerClickIcon className="w-4 h-4 mr-2" strokeWidth={1}/>Geselecteerde documenten toevoegen</button></DropdownMenuItem>
                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenu>

            
            <AlertDialog open={open_addnewdocument} onOpenChange={(o)=>{setopen_addnewdocument(o)}}><AddNewDocument onSuccess={()=>{setopen_addselecteddocuments(false)}} dossier={dossier}/></AlertDialog>
            <AlertDialog open={open_addselecteddocuments} onOpenChange={(o)=>{setopen_addselecteddocuments(o)}}><AddSelectedDocuments onSuccess={()=>{setopen_addselecteddocuments(false)}} dossier={dossier}/></AlertDialog>
            <AlertDialog open={open_addmanualdocument} onOpenChange={(o)=>{setopen_addmanualdocument(o)}}><AddManualDocument onSuccess={()=>{setopen_addselecteddocuments(false)}} dossier={dossier}/></AlertDialog>
        </>  
    )
}

const Dossier : React.FC = () => {
    const {auth} = useAuth()
    const {t, i18n} = useTranslation()
    const dossiertypes:DossiertypeObject[] = useAppSelector((state:RootState) => state.dossiertypes)
    const metatypes:MetatypeObject[] = useAppSelector((state:RootState) => state.metatypes);
    const doctypes:DoctypeObject[] = useAppSelector((state:RootState) => state.doctypes)
    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const { dossier } = useParams();

    const [show_filepreview, setshow_filepreview] = useState(false);

    const [show_dropdown, setshow_dropdown] = useState(false);
    const dropdownRef = useRef() as MutableRefObject<HTMLDivElement>
    useOnClickOutside(dropdownRef, () => { if(show_dropdown){ setshow_dropdown(false) } })

    const [selectedDocument, setselectedDocument] = useState<DocumentObject>()

    const [resultState, setresultState] = useState<'loading' | 'error' | 'success'>('loading');
    const [result, setresult] = useState<DossierObject>();
    const [events, setevents] = useState<DocumentObject[]>();
    const [documents, setdocuments] = useState<DossierDocument[]>();

    const [viewType, setviewType] = useState<'grid' | 'list'>('list');

    useEffect(()=>{
        let dvt = window.localStorage.getItem('d_vt')
        if(dvt === 'list' || dvt === 'grid'){
            setviewType(dvt)
        }
    }, [])

    useEffect(()=>{
        if(dossier){
            handleGetDossier(parseFloat(dossier));
        }
    }, [dossier])

    useEffect(()=>{
        if(viewType){
            window.localStorage.setItem('d_vt', viewType)
        }
    }, [viewType])

    function resolveAfterSeconds(seconds:number) {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve('resolved');
          }, seconds*1000);
        });
    }

    const handleGetDossier = async (dossierentityid:number) => {
        await resolveAfterSeconds(0)
        const {data:dossier} = await axios.get(`dossiers/get?dossierentityid=${dossierentityid}`)
        if(dossier.errorcode === 0){
            if(Array.isArray(dossier.object)){
                setresultState('success')
                setresult(dossier.object[0])
                setevents(getEvents(dossier.object[0]))
                setdocuments(dossier.object[0].documents)
            }
            else {
                console.log(dossier)
                setresultState('error')
                dispatch(setNotification({type:'error', title:t('Error'), message:t('Dit dossier werd niet gevonden')}))
            }
        }
        else {
            console.log(dossier)
            setresultState('error')
            dispatch(setNotification({type:'error', title:t('Error'), message:t('Er liep iets mis tijdens het ophalen van dit dossier')}))
        }
    }

    const getEvents = (dossier:DossierObject) => {
        const documents = dossier.documents.map(d => {
            const document = {...d.document}
            const visibleMetatypes = metatypes.filter(i=>i.columndisplay && i.metatype !== 'RELNA')
            document.metadata = document.metadata?.filter(m => visibleMetatypes.find(i=>i.metatype === m.metatype))
            return document
        }).sort((a, b)=>a.docid - b.docid);
        
        return documents
    }

    const extensionToIcon = (extension:string) => {
        switch (extension) {
            case 'doc': case 'docx' :
                return word_icon
            case 'xlsx':
                return excel_icon
            case 'pdf':
                return pdf_icon
            case 'txt':
                return text_icon
            case 'ppt':
                return powerpoint_icon
            case 'eml': case 'msg':
                return mail_icon;
            case 'jpg': case 'jpeg': case 'png':
                return image_icon;
            default:
                return unknown_icon
        }
    }

    const searchDocuments = (value:string) => {
        if(result){
            const filtered_docs = filterObjectsByValue(result.documents, value) as DossierDocument[]
            setdocuments(filtered_docs);

            const filtered_events = getEvents({...result, documents:filtered_docs})
            setevents(filtered_events)
        }
    }

    const metatypeToName = (metatype:string) => {
        if(!Array.isArray(metatypes)) return metatypes;

        const mt = metatypes.find(i=>i.metatype === metatype)
        if(!mt) return metatype;

        return mt.metatype_oms.find(i=>i.nationid === getWindevLang(i18n.language))?.oms || metatype
    }

    const getColumns = (results:DossierDocument[]) => {
        let result:any[] = []
        let metatypeArray:string[] = []
        results.forEach(element => {
            if(element.document){
                if(element.document.metadata){
                    return element.document.metadata.forEach(md => {
                        if(!metatypeArray.includes(md.metatype)){ metatypeArray.push(md.metatype) }
                    })
                }
            }
        });
        result = metatypeArray.filter(mt => {
            const item = metatypes.find(i=>i.metatype===mt)
            return item?.columndisplay
        })
        return result
    }

    const documentsAreaRef = useRef(null)
    const documentsRef = useRef<any>({})
    const [highlighted_row, sethighlighted_row] = useState<string | null>(null);

    const scrollToRow = (id:string) => {
        const row = documentsRef.current[id];
        if (row && documentsAreaRef.current) {
            row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            sethighlighted_row(id);
        }
    };

    return (
    <>
        <Toaster />

        {(show_filepreview && selectedDocument) && 
            <FilePreview document={selectedDocument} onClose={()=>{setshow_filepreview(false)}}/>
        }

        <div className='flex flex-col overflow-auto h-dvh'>
            <div className='relative flex flex-col gap-2 p-16 bg-primary'>
                <button onClick={()=>{navigate(-1)}} className="relative z-10 flex items-center gap-1 py-1 pl-2 pr-3 text-sm font-medium text-white duration-200 -translate-x-2 rounded-full w-fit bg-white/0 hover:bg-white/20"><ChevronLeft className="w-3.5 h-3.5"/> Terug</button>
                <h1 className='relative z-10 text-3xl font-bold text-white'>{result?.extendeddescription || t("Geen omschrijving")}</h1>
                <p className='relative z-10 text-sm text-white uppercase'>{t('Bekijk hier de documenten binnen dit dossier')}</p>

                <img src={bgImage} alt="bg" className='absolute top-0 left-0 object-cover w-full h-full'/>
            </div>

            <div className="flex flex-col gap-8 px-16 py-8">
                <div className='flex flex-col gap-4 p-8 bg-white border rounded-lg shadow-sm'>
                    <div className="flex flex-col gap-2">
                        <h2 className='text-2xl font-semibold'>Algemene informatie</h2>
                        <p className="text-sm text-neutral-600">{t('Aangemaakt op')}: <span className="font-medium">{result && isValid(new Date(result.creationdate)) && format(new Date(result.creationdate), "d MMMM yyyy")}</span></p>
                        <p className="text-sm text-neutral-600">{t('Dossiertype')}: <span className="font-medium">{result && result.dossiertypeid && getItemById(dossiertypes, "dossiertypeid", result.dossiertypeid)?.name}</span></p>
                        <p className="text-sm text-neutral-600">{t('Laatst aangepast')}: <span className="font-medium">{result && isValid(new Date(result.deadline)) && format(new Date(result.deadline), "d MMMM yyyy")}</span></p>
                    </div>
                </div>

                <div className="flex flex-col gap-4">
                    <div className="flex flex-wrap-reverse items-center justify-between gap-4">
                        <Input onChange={({currentTarget}) => {searchDocuments(currentTarget.value)}} placeholder={`${t('Document zoeken')}...`} className="text-sm w-fit" startEnhancer={<Search className="w-4 h-4 text-neutral-400"/>}/>
                        
                        {dossier && <New dossier={dossier}/>}
                    </div>

                        <ResizablePanelGroup direction="horizontal" className="grid w-full gap-4 md:grid-cols-2">
                            <ResizablePanel>
                                <ScrollArea ref={documentsAreaRef} className="max-h-[90dvh] border rounded-md bg-white">
                                    <div className="w-full h-full">
                                    <Table className="text-sm">
                                        <TableHeader>
                                            <TableRow>
                                                <TableHead className="p-2 whitespace-nowrap">{t('Doc datum')}</TableHead>
                                                <TableHead className="p-2">{t('Type')}</TableHead>
                                                <TableHead className="p-2"></TableHead>
                                                <TableHead className="p-2">{t('Bestandsinfo')}</TableHead>
                                                {documents && getColumns(documents).map((v, i)=>(
                                                    <TableHead className="p-2" key={i}>{metatypes.find(i=>i.metatype===v)?.metatype_oms?.find(i=>i.nationid===getWindevLang(i18n.language))?.oms || v}</TableHead>
                                                ))}
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody>
                                        {documents && 
                                        documents
                                        .filter(d=>!!d.document)
                                        .sort((a,b)=> parseFloat(b.document?.docdate) - parseFloat(a.document?.docdate))
                                        .map((value, index) => {
                                            if(!value.document) { return; }
                                            return (
                                                <TableRow 
                                                    id={value.docid.toString()}
                                                    ref={el => documentsRef.current[value.docid.toString()] = el}
                                                    className={`${highlighted_row === value.docid.toString() && 'bg-blue-100'} cursor-pointer hover:bg-blue-100  group`} 
                                                    onClick={()=>{setshow_filepreview(true); setselectedDocument(value.document)}} 
                                                    key={index}
                                                >
                                                    <TableCell className="p-2">{format(YYYYMMDDtoDate(value.document.docdate), "dd/MM/yyyy")}</TableCell>
                                                    <TableCell className="p-2">{doctypes ? (doctypes.find(i=>i.doctype===value.document.doctype)?.docoms.find(i=>i.nationid===getWindevLang(i18n.language))?.oms) : value.document.doctype}</TableCell>
                                                    <TableCell className="p-2"><img className='w-6 min-w-[24px] h-6' src={extensionToIcon(value.document.filename.split('.')[value.document.filename.split('.').length - 1] || '')} alt="Filetype Icon"/></TableCell>
                                                    <TableCell className="p-2">
                                                        <p>DOCID: {value.docid}</p>
                                                        <p>File: {value.document.filename}</p>
                                                    </TableCell>
                                                    {documents && getColumns(documents).map((v, i)=>(
                                                        <TableCell className="p-2" key={i}>{value.document && value.document.metadata && value.document.metadata.find(md => md.metatype === v)?.metavalue || ''}</TableCell>
                                                    ))}
                                                </TableRow>
                                            )
                                        })}
                                        </TableBody>
                                    </Table>
                                    </div>
                                    <ScrollBar orientation="horizontal"/>
                                </ScrollArea>
                            </ResizablePanel>

                            <ResizableHandle withHandle/>
                            
                            <ResizablePanel>
                                <ScrollArea className="max-h-[90dvh]">
                                    <div className="w-full h-full">
                                        <div className='flex flex-col gap-4'>
                                            {events 
                                            && events
                                            .sort((a,b)=> parseFloat(b.docdate) - parseFloat(a.docdate))
                                            .map((value, index) => {
                                                return (
                                                    <div onClick={()=>{scrollToRow(value?.docid?.toString())}} id={value?.docid?.toString()} className='flex items-start w-full p-4 bg-white border rounded-md cursor-pointer hover:bg-blue-100 hover:border-blue-300 group' key={index}>
                                                        <div className="w-8 py-2">
                                                            <MessageCircleIcon className="w-4 h-4 text-neutral-600 group-hover:text-blue-700"/>
                                                        </div>
                                                    
                                                        <div className="flex flex-col w-full gap-4">
                                                            <div>
                                                                <p className='font-bold'>{value?.filename}</p>
                                                                <p className='text-xs text-neutral-400'>{isValid(new Date(YYYYMMDDtoDate(value?.docdate))) && format(new Date(YYYYMMDDtoDate(value?.docdate)), "d MMMM yyyy")}</p>
                                                            </div>
                                                            <div className='flex flex-col w-full gap-2'>
                                                                {value?.metadata?.map((metadata, index) => {
                                                                    return (
                                                                        <div className='w-full p-2 border-l rounded-r-sm bg-neutral-100 border-l-primary group-hover:bg-blue-200' key={index}>
                                                                            <p className="text-sm font-medium text-neutral-900">{metatypeToName(metadata?.metatype)}</p>
                                                                            <p className='text-sm text-neutral-600'>{metadata?.metavalue}</p>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}   
                                        </div>
                                    </div>
                                </ScrollArea>
                            </ResizablePanel>
                        </ResizablePanelGroup>

                </div>
            </div>
        </div>

        {/* <div className={styles.dossier}>
            <div className={styles.bg_image}></div>

            {(result && resultState === 'success') && 
            <div className={`${styles.content} p-4 md:p-16`}>
                <div className={styles.actions}>
                    <button className='flex items-center justify-center w-10 h-10 rounded-full bg-white/50 backdrop-blur-sm text-neutral-800 hover:bg-white/60' onClick={()=>{navigate(-1)}}><ChevronLeft className="w-5 h-5 -translate-x-0.5"/></button>
                </div>

                <div className='flex flex-col gap-4 p-8 bg-white border rounded-lg shadow-sm'>
                    <h1 className='text-2xl font-semibold'>{result.extendeddescription || t("Geen omschrijving")}</h1>

                    <div className={styles.header}>
                        <p className={styles.bold}>{t('Aangemaakt op')}: {format(new Date(result.creationdate), "d MMMM yyyy")}</p>
                        <p className={styles.bold}>{t('Dossiertype')}: {getItemById(dossiertypes, "dossiertypeid", result.dossiertypeid)?.name}</p>
                        {isValid(result.deadline) && <p className={styles.bold}>{t('Laatst aangepast')}: {format(new Date(result.deadline), "d MMMM yyyy")}</p>} 
                    </div>
                </div>

                <div className='flex items-center justify-between my-8'>
                    <Input onChange={({currentTarget}) => {searchDocuments(currentTarget.value)}} placeholder={`${t('Document zoeken')}...`} className="text-sm" startEnhancer={<Search className="w-4 h-4 text-neutral-400"/>}/>
                </div>

                <div className={`${styles.body} grid md:grid-cols-[2fr,1fr] gap-10`}>
                    <div className='overflow-auto'>
                        <Table className="text-sm">
                            <TableHeader>
                                <TableRow>
                                    <TableHead className="p-2 whitespace-nowrap">{t('Doc datum')}</TableHead>
                                    <TableHead className="p-2">{t('Type')}</TableHead>
                                    <TableHead className="p-2"></TableHead>
                                    <TableHead className="p-2">{t('Bestandsinfo')}</TableHead>
                                    {documents && getColumns(documents).map((v, i)=>(
                                        <TableHead className="p-2" key={i}>{metatypes.find(i=>i.metatype===v)?.metatype_oms?.find(i=>i.nationid===getWindevLang(i18n.language))?.oms || v}</TableHead>
                                    ))}
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                            {documents && documents.map((value, index) => {
                                if(!value.document) { return; }
                                return (
                                    <TableRow className="cursor-pointer hover:bg-blue-100 group" onClick={()=>{setshow_filepreview(true); setselectedDocument(value.document)}} key={index}>
                                        <TableCell className="p-2">{format(new Date(value.dateadded), "dd/MM/yyyy")}</TableCell>
                                        <TableCell className="p-2">{doctypes ? (doctypes.find(i=>i.doctype===value.document.doctype)?.docoms.find(i=>i.nationid===getWindevLang(i18n.language))?.oms) : value.document.doctype}</TableCell>
                                        <TableCell className="p-2"><img className='w-6 min-w-[24px] h-6' src={extensionToIcon(value.document.filename.split('.')[value.document.filename.split('.').length - 1] || '')} alt="Filetype Icon"/></TableCell>
                                        <TableCell className="p-2">
                                            <p>DOCID: {value.docid}</p>
                                            <p>File: {value.document.filename}</p>
                                        </TableCell>
                                        {documents && getColumns(documents).map((v, i)=>(
                                            <TableCell className="p-2" key={i}>{value.document && value.document.metadata && value.document.metadata.find(md => md.metatype === v)?.metavalue || ''}</TableCell>
                                        ))}
                                    </TableRow>
                                )
                            })}
                            </TableBody>
                        </Table>
                    </div>

                    <div className={`${styles.timeline} !border-none`}>
                        {events && Object.keys(events).map((value, index) => {
                            return (
                                <div className={styles.card} key={index}>
                                    <div className={styles.left}>
                                        <div className={styles.icon}><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 7.66669C14.0023 8.5466 13.7967 9.41461 13.4 10.2C12.9296 11.1412 12.2065 11.9328 11.3116 12.4862C10.4168 13.0396 9.3855 13.3329 8.33333 13.3334C7.45342 13.3356 6.58541 13.1301 5.8 12.7334L2 14L3.26667 10.2C2.86995 9.41461 2.66437 8.5466 2.66667 7.66669C2.66707 6.61452 2.96041 5.58325 3.51381 4.68839C4.06722 3.79352 4.85884 3.0704 5.8 2.60002C6.58541 2.20331 7.45342 1.99772 8.33333 2.00002H8.66667C10.0562 2.07668 11.3687 2.66319 12.3528 3.64726C13.3368 4.63132 13.9233 5.94379 14 7.33335V7.66669Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
                                        <div className={styles.line_ct}>
                                            <div className={styles.line}></div>
                                        </div>
                                    </div>
                                    <div className={styles.right}>
                                        <div className={styles.top}>
                                            <p className={styles.type}>{events[value].name}</p>
                                            <p className={styles.date}>{format(new Date(events[value].date), "d MMMM yyyy")}</p>
                                        </div>
                                        <p className={styles.description}>{t('Opmerking')}</p>
                                        <div className={styles.messages}>
                                            {events[value].items.map((item, index) => {
                                                return (
                                                    <div className={styles.message} key={index}>
                                                        <p className={styles.text}>{item}</p>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}   
                    </div>
                    
                    
                </div>
            </div>
            }

            {resultState === "error" &&
            <p>Oh nee! Een error</p>
            }

            {resultState === "loading" &&
            <div className={`${styles.content} p-4 md:p-16`}>
                <div className={styles.actions}>
                    <button className={styles.backbutton} onClick={()=>{navigate(-1)}}><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>
                </div>

                <div className={styles.head}>
                    <Skeleton height={30} width={200}/>

                    <div className={styles.header}>
                        <Skeleton width={200}/>
                        <Skeleton width={100}/>
                    </div>
                </div>

                <div className={styles.actions}>
                    <Skeleton height={48} width={200}/>
                    <Skeleton height={48} width={200}/>
                </div>


                <div className={styles.body}>
                    <div className={styles.timeline}>
                        <Skeleton height={80} count={3} width={200} style={{display:"flex", gap:"2rem"}}/>
                    </div>
                    <div className={styles.list}>
                        <Skeleton height={80} count={3} width={200} style={{display:"flex", gap:"2rem", marginLeft:"1rem"}}/>
                    </div>
                </div>

            </div>
            }

        </div> */}
    </>
    )
}

export default Dossier;